import React, { Component } from "react";

const tabStyle = {
  background: "#00b5ef",
  color: "#fff",
  fontWeight: "600",
};
export class ScreenOption extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="crossProjectSec">
        <div className="customNumberRadioButton">
          {this.props.pageList.map((d, idx) => {
            return (
              <label className="radioButtonNumbers">
                <input
                  checked={d.screen == this.props.selectedScreen}
                  onChange={this.props.onChangeScreen}
                  type="radio"
                  name={d.name}
                  value={d.screen}
                />
                <span style={this.props.pageValue==d.screen? tabStyle : {}}>
                  {d.screen}
                </span>
              </label>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ScreenOption;
